import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';
import { userType } from '@atlassiansox/analytics-web-client/analytics-web-types';
import { analyticsClient } from '../analytics/analyticsClient';
import { logError } from '../utils/logger';
import { STATSIG_FEATURE_GATES } from './statsigFeatureGates';

let attempted = false;

const reportFailure = (): void => {
	try {
		// SDK errors may contain identifiers or URLs. Keep the diagnostic payload fixed.
		logError({
			error: new Error('Uninstall analytics failed'),
			impact: 'Failed to send uninstall track event',
		});
	} catch {
		// Diagnostics must not interrupt application readiness either.
	}
};

/** Called after normal gate initialization. Records a URL visit, not verified removal. */
export const trackExtensionUninstall = (atlassianAccountId?: string): void => {
	try {
		const { pathname, search } = window.location;
		if (
			attempted ||
			(pathname !== '/extension/uninstall' && pathname !== '/extension/uninstall/') ||
			window.self !== window.top
		) {
			return;
		}

		const params = new URLSearchParams(search);
		const installationId = params.get('install');
		if (!installationId || !/^[a-zA-Z0-9_-]{1,128}$/.test(installationId)) {
			return;
		}

		if (
			!FeatureGates.checkGate(STATSIG_FEATURE_GATES.UNINSTALLATION_ANALYTICS, {
				fireGateExposure: false,
			})
		) {
			return;
		}

		const version = params.get('version');
		const extensionVersion =
			version && version.length <= 64 && /^\d+(\.\d+){0,3}$/.test(version) ? version : undefined;
		attempted = true;
		if (atlassianAccountId) {
			analyticsClient.setUserInfo(userType.ATLASSIAN_ACCOUNT, atlassianAccountId);
		} else {
			analyticsClient.clearUserInfo();
		}
		// https://data-portal.internal.atlassian.com/analytics/registry/113064
		void analyticsClient
			.sendTrackEvent({
				source: 'extensionUninstallPage',
				actionSubject: 'extension',
				action: 'uninstalled',
				attributes: {
					installationId,
					...(extensionVersion ? { extensionVersion } : {}),
				},
			})
			.catch(reportFailure);
	} catch {
		reportFailure();
	}
};
